import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchUserDashboard } from '../../../../api/userDashboardApi';
import '../TrainingMockExamSection.css';

const Training = () => {
  const [trainingData, setTrainingData] = useState([]);
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const fetchDashboard = async () => {
      try {
        const dashboard = await fetchUserDashboard(userId);
        setTrainingData(dashboard?.training || []);
      } catch (error) {
        // console.error('Error fetching dashboard data:', error);
        setTrainingData([]);
      } finally {
        setLoading(false); 
      }
    };

    fetchDashboard();
  }, []);

  return (
    <div className="training-exam-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 className='heading-for-dashboard-user' style={{ textAlign: 'start' }}>🎗️ Training</h2>
        <Link to="/user/training">
          <p className="view-all-btn-training">View All Trainings</p>
        </Link>
      </div>
      
      {loading ? (
        <div className="spinner-container">
          <div className="spinner"></div>
        </div>
      ) : trainingData.length === 0 ? (
        <div className="spinner-container">
          <div className="no-data-user-dashboard">No Training Assigned!</div>
        </div>
      ) : (
        <div className="training-container">
          {trainingData.slice(0, 3).map((training) => (
            <div className="insurance-card" key={training.trainingId}>
              <div className="card-header">
                <h2>{training.trainingName}</h2>
                <div className="category">
                  <Link to={`/user/training`}>
                    <button className="go-to-training-btn">Go to Training</button>
                  </Link>
                </div>
              </div>
              <div className="policy-details">
                <div className="detail-row">
                  <span className="label">Description:</span>
                  <span className="value">{training.trainingDescription}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Duration (mins):</span>
                  <span className="value">{training.trainingDuration}</span>
                </div>
                <div className={`status ${training.trainingstatus === 'not started' ? 'inactive' : 'active'}`}>
                  {training.trainingstatus}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Training;
